import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { GiftIcon, ChevronDownIcon } from 'lucide-react';
const bonuses = [{
  name: 'Guía de Hierbas Curativas',
  price: 290,
  desc: '50 plantas medicinales y cómo usarlas.'
}, {
  name: 'Recetario Anti-Estrés',
  price: 250,
  desc: 'Infusiones para calmar ansiedad.'
}, {
  name: 'Plan Detox de 7 Días',
  price: 350,
  desc: 'Eliminar toxinas y recuperar energía.'
}, {
  name: 'Guía de Tés Medicinales',
  price: 190,
  desc: '30 tés curativos para cada día.'
}, {
  name: 'Remedios para Dormir Mejor',
  price: 220,
  desc: 'Soluciones naturales para el insomnio.'
}, {
  name: 'Recetas para la Digestión',
  price: 280,
  desc: 'Alivio para gases, acidez y malestar.'
}, {
  name: 'Guía de Aceites Esenciales',
  price: 310,
  desc: 'Aromaterapia para salud y bienestar.'
}, {
  name: 'Protocolo Inmunológico',
  price: 270,
  desc: 'Fortalecé tus defensas naturalmente.'
}, {
  name: 'Recetario para Articulaciones',
  price: 240,
  desc: 'Alivio del dolor articular natural.'
}, {
  name: 'Guía de Alimentación Ancestral',
  price: 330,
  desc: 'Nutrición natural para vivir mejor.'
}];
const totalValue = bonuses.reduce((s, b) => s + b.price, 0);
export function BonusSection() {
  const [open, setOpen] = useState(false);
  return <section className="bg-ancestral-green py-12 md:py-16 text-ancestral-cream" data-id="element-98">
      <div className="container mx-auto px-4" data-id="element-99">
        <div className="max-w-2xl mx-auto text-center" data-id="element-100">
          <FadeIn data-id="element-101">
            {/* Image */}
            <div className="max-w-md mx-auto mb-8" data-id="element-102">
              <img src="https://cdn.magicpatterns.com/uploads/d6J6goDXbnsg3CFCbjmxYh/WhatsApp_Image_2026-03-16_at_20.22.46.jpg" alt="10 Libros de Regalo" className="w-full rounded-2xl shadow-2xl border border-ancestral-gold/20" data-id="element-103" />
            </div>

            {/* Title */}
            <p className="text-xs uppercase tracking-[0.2em] text-ancestral-gold/70 font-semibold mb-3" data-id="element-104">
              ⚡ Bonus exclusivo — Solo por hoy
            </p>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-ancestral-gold mb-4" data-id="element-105">
              10 Bonos de Regalo con Tu Compra
            </h2>

            {/* Value highlight */}
            <div className="flex items-center justify-center gap-3 flex-wrap mb-3" data-id="element-106">
              <span className="text-lg text-ancestral-cream/60" data-id="element-107">
                Valorados en
              </span>
              <span className="text-2xl md:text-3xl font-bold text-red-400 line-through" data-id="element-108">
                ${totalValue.toLocaleString()} UYU
              </span>
            </div>
            <div className="inline-block bg-emerald-500 text-white font-bold text-lg md:text-xl px-6 py-2 rounded-full shadow-lg mb-8" data-id="element-109">
              🎁 HOY: COMPLETAMENTE GRATIS
            </div>

            {/* Toggle button */}
            <div data-id="element-110">
              <button onClick={() => setOpen(!open)} className="inline-flex items-center gap-2 text-ancestral-gold border border-ancestral-gold/40 rounded-full px-6 py-2.5 text-sm font-semibold hover:bg-ancestral-gold/10 transition-colors" data-id="element-111">
                {open ? 'Ocultar bonos' : 'Ver los 10 bonos incluidos'}
                <motion.div animate={{
                rotate: open ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-112">
                  <ChevronDownIcon className="w-4 h-4" data-id="element-113" />
                </motion.div>
              </button>
            </div>
          </FadeIn>

          {/* Expandable bonus list */}
          <AnimatePresence data-id="element-114">
            {open && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.4,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-115">
                <div className="pt-8 grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-xl mx-auto" data-id="element-116">
                  {bonuses.map((b, i) => <div key={i} className="flex items-start gap-3 bg-white/5 border border-ancestral-gold/15 rounded-xl px-4 py-3 text-left" data-id="element-117">
                      <GiftIcon className="w-4 h-4 text-ancestral-gold flex-shrink-0 mt-0.5" data-id="element-118" />
                      <div className="min-w-0" data-id="element-119">
                        <div className="flex items-center gap-2 flex-wrap" data-id="element-120">
                          <span className="font-bold text-sm text-ancestral-cream" data-id="element-121">
                            {b.name}
                          </span>
                          <span className="text-[10px] text-red-400 line-through" data-id="element-122">
                            ${b.price}
                          </span>
                          <span className="text-[9px] font-bold bg-emerald-500/90 text-white px-1.5 py-0.5 rounded uppercase" data-id="element-123">
                            Gratis
                          </span>
                        </div>
                        <p className="text-xs text-ancestral-cream/45 mt-0.5" data-id="element-124">
                          {b.desc}
                        </p>
                      </div>
                    </div>)}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}